import { render, staticRenderFns } from "./AnswerReports.vue?vue&type=template&id=50bb878e&scoped=true&"
import script from "./AnswerReports.vue?vue&type=script&lang=js&"
export * from "./AnswerReports.vue?vue&type=script&lang=js&"
import style0 from "./AnswerReports.vue?vue&type=style&index=0&id=50bb878e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bb878e",
  null
  
)

export default component.exports